// extracted by mini-css-extract-plugin
export default {"loader_body":"style_loader_body__RxK7V","lds_roller":"style_lds_roller__cZ8bC"};